import { Box, Typography } from '@mui/material';
import { Appointment, GeneralRequest } from '../../interfaces';
import { getCustomerNameFromAppointment } from '../../utils/global/helper';
import TableImage from '../table/TableImage';

interface Props {
  appointment: Appointment | GeneralRequest;
  onOpenRequest: (appointment: Appointment | GeneralRequest) => void;
  isUnread?: boolean;
}

export default function RequestCard({
  appointment,
  onOpenRequest,
  isUnread,
}: Props) {
  // Opening the request clears the marker; the decline only picks which one
  const isDeclined = !!(appointment as Appointment).offeredTimesDeclinedAt;

  return (
    <Box
      onClick={() => onOpenRequest(appointment)}
      style={{
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 5,
        maxWidth: '140px',
      }}>
      <TableImage
        image={appointment.refImgsId?.[0]}
        badge={isUnread && !isDeclined}
        needsAttention={isUnread && isDeclined}
        width="140px"
      />
      <div style={{ paddingTop: 10 }}>
        <Typography variant="h5" className="ellipsis">
          {'appointmentId' in appointment && appointment.employee
            ? `${appointment.employee.firstName} ${appointment.employee.lastName}`
            : 'Any artist'}
        </Typography>
        <Typography variant="body2" className="ellipsis">
          {getCustomerNameFromAppointment(appointment)}
        </Typography>
      </div>
    </Box>
  );
}
